<div class="container-fluid">
  <div class="row">
    <div class="col-12">
      <div class="page-title-box d-sm-flex align-items-center justify-content-between">
        <app-rp-breadcrumb [breadcrumbItems]="breadCrumbItems"></app-rp-breadcrumb>

        <span>
          <ul class="list-inline wizard d-flex justify-content-end mb-0 mt-4">
            <li class="next list-inline-item" *ngIf="
                metersDBData?.approvalStatus === 'AgentMapped' ||
                metersDBData?.approvalStatus === 'AgentUnmapped'
              ">
              <button class="btn btn-primary green" (click)="approvalConfiramation('approve', '')">
                Approve
              </button>
            </li>
            <li class="next list-inline-item" *ngIf="
                metersDBData?.approvalStatus === 'AgentMapped' ||
                metersDBData?.approvalStatus === 'AgentUnmapped'
              ">
              <button class="btn btn-danger" (click)="approvalConfiramation('reject', invalidBillModal)">
                Reject
              </button>
            </li>
            @if (cdkStepper.selectedIndex === 2) {
            <span class="breadcrumb m-0">
              <button class="btn btn-primary d-flex align-items-center" (click)="exportAll()">
                <span class="fas fa-file-excel"> </span> &nbsp;Export All to
                Excel
              </button>
            </span>
            }
          </ul>
        </span>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-lg-12">
      <div class="card">
        <div class="card-body">
          <!-- <h4 class="card-title mb-4"></h4> -->
          <div>
            <ng-stepper #cdkStepper [linear]="true" class="wizard" (selectionChange)="tabChange($event)">
              <cdk-step [optional]="false" [ariaDisabled]="true">
                <ng-template cdkStepLabel>
                  <!--  <span class="number">1</span> -->
                  <span>DB Meters details </span>
                </ng-template>
                @if (cdkStepper.selectedIndex === 0) {
                <section class="">
                  <form class="form-horizontal" [formGroup]="editDBMetersForm">
                    <div class="row">
                      <div class="col-lg-4">
                        <div class="mb-3">
                          <label>Utility
                            <span class="required">*</span></label>
                          <ng-select [items]="meterUtilities" bindLabel="name" id="utilityMasterId"
                            name="utilityMasterId" bindValue="id" formControlName="utilityMasterId" [multiple]="false"
                            appendTo="body" [placeholder]="'Select...'" (change)="changeUtility($event)"></ng-select>
                          @if (
                          submitted &&
                          editDBMetersForm.controls["utilityMasterId"]
                          .errors
                          ) {
                          <div class="invalid-feedback">
                            @if (
                            editDBMetersForm.controls["utilityMasterId"]
                            .errors["required"]
                            ) {
                            <div>
                              {{
                              Umd_Validations.utilityMasterId.required
                              }}
                            </div>
                            }
                          </div>
                          }
                        </div>
                      </div>
                      <div class="col-lg-4">
                        <div class="mb-3">
                          <label>Mac Address<span class="required">*</span></label>
                          <input type="text" formControlName="macAddress" id="macAddress" class="form-control"
                            placeholder="Enter Mac Address" />
                          @if (
                          submitted &&
                          editDBMetersForm.controls["macAddress"].errors
                          ) {
                          <div class="invalid-feedback d-block">
                            <!-- Required -->
                            @if (
                            editDBMetersForm.controls["macAddress"]
                            .errors["required"]
                            ) {
                            <div>
                              {{ Umd_Validations.macAddress.required }}
                            </div>
                            }

                            <!-- Pattern (different msg for wired / not wired) -->
                            @if (
                            editDBMetersForm.controls["macAddress"]
                            .errors["pattern"] &&
                            !this.iswirdeCommunication
                            ) {
                            <div>
                              {{ Umd_Validations.macAddress.pattern }}
                            </div>
                            }
                            @if (
                            editDBMetersForm.controls["macAddress"]
                            .errors["pattern"] &&
                            this.iswirdeCommunication
                            ) {
                            <div>
                              {{
                              Umd_Validations.macAddress.isWiredPattern
                              }}
                            </div>
                            }

                            <!--Is wired :true  start  (min and max same Exactly 7 char)-->
                            @if (
                            editDBMetersForm.controls["macAddress"]
                            .errors["minlength"] &&
                            iswirdeCommunication
                            ) {
                            <div>
                              {{ Umd_Validations.macAddress.Ismwiredmax }}
                            </div>
                            }
                            @if (
                            editDBMetersForm.controls["macAddress"]
                            .errors["maxlength"] &&
                            iswirdeCommunication
                            ) {
                            <div>
                              {{ Umd_Validations.macAddress.Ismwiredmax }}
                            </div>
                            }

                            <!--Is wired :false  start  (min and max :Exactly 16)-->

                            @if (
                            editDBMetersForm.controls["macAddress"]
                            .errors["maxlength"] &&
                            !iswirdeCommunication
                            ) {
                            <div>
                              {{ Umd_Validations.macAddress.maxlength }}
                            </div>
                            }
                            @if (
                            editDBMetersForm.controls["macAddress"]
                            .errors["minlength"] &&
                            !iswirdeCommunication
                            ) {
                            <div>
                              {{ Umd_Validations.macAddress.maxlength }}
                            </div>
                            }

                          </div>
                          }
                        </div>
                      </div>
                      <div class="col-lg-4">
                        <div class="mb-3">
                          <label>Device Sr No
                            <span class="required">*</span></label>
                          <input type="text" formControlName="meterSerialNo" id="meterSerialNo" class="form-control"
                            placeholder="Enter Meter Serial Number" />

                          @if (
                          submitted &&
                          editDBMetersForm.controls["meterSerialNo"].errors
                          ) {
                          <div class="invalid-feedback d-block">
                            <!-- Required -->
                            @if (
                            editDBMetersForm.controls["meterSerialNo"]
                            .errors["required"]
                            ) {
                            <div>
                              {{ Umd_Validations.meterSerialNo.required }}
                            </div>
                            }

                            <!-- Pattern (different msg for wired / not wired) -->
                            @if (
                            editDBMetersForm.controls["meterSerialNo"]
                            .errors["pattern"] &&
                            this.iswirdeCommunication
                            ) {
                            <div>
                              {{ Umd_Validations.meterSerialNo.pattern }}
                            </div>
                            }
                            @if (
                            editDBMetersForm.controls["meterSerialNo"]
                            .errors["pattern"] &&
                            !this.iswirdeCommunication
                            ) {
                            <div>
                              {{
                              Umd_Validations.meterSerialNo
                              .isNotWiredPattern
                              }}
                            </div>
                            }

                            @if (
                            editDBMetersForm.controls["meterSerialNo"]
                            .errors["minlength"] &&
                            !this.iswirdeCommunication
                            ) {
                            <div>
                              {{
                              Umd_Validations.meterSerialNo.minlength
                              }}
                            </div>
                            }
                            @if (
                            editDBMetersForm.controls["meterSerialNo"]
                            .errors["maxlength"] &&
                            !this.iswirdeCommunication
                            ) {
                            <div>
                              {{
                              Umd_Validations.meterSerialNo.maxlength
                              }}
                            </div>
                            }

                            <!-- end -->

                            <!--Is wired :true  start  (min and max :Exactly 7)-->
                            @if (
                            editDBMetersForm.controls["meterSerialNo"]
                            .errors["maxlength"] &&
                            this.iswirdeCommunication
                            ) {
                            <div>
                              {{
                              Umd_Validations.meterSerialNo.Ismwiredmax
                              }}
                            </div>
                            }
                            @if (
                            editDBMetersForm.controls["meterSerialNo"]
                            .errors["minlength"] &&
                            this.iswirdeCommunication
                            ) {
                            <div>
                              {{
                              Umd_Validations.meterSerialNo.Ismwiredmax
                              }}
                            </div>
                            }
                          </div>
                          }
                        </div>
                      </div>

                      <div class="col-lg-4">
                        <div class="mb-3" style="margin-top: 30px" *ngIf="
                              selectedutlity?.name == 'Electricity' ||
                              selectedutlity?.name == 'TriSource'
                            ">
                          <input class="form-check-input" type="checkbox" (change)="onCheckboxChange($event)"
                            formControlName="isWiredCommunicationDevice" id="formCheck1" />&nbsp;
                          <label class="form-check-label" for="formCheck1">Is Wired Communication Device</label>
                        </div>
                      </div>

                      <div class="col-lg-4">
                        <div class="mb-3" *ngIf="iswirdeCommunication">
                          <label>Device id <span class="required">*</span></label>
                          <input type="text" class="form-control" formControlName="deviceId" id="deviceId"
                            name="deviceId" placeholder="Enter deviceId Number" />
                          @if (
                          submitted &&
                          editDBMetersForm.controls["deviceId"].errors
                          ) {
                          <div class="invalid-feedback d-block">
                            @if (
                            editDBMetersForm.controls["deviceId"].errors[
                            "required"
                            ]
                            ) {
                            <div>
                              {{ Umd_Validations.deviceId.required }}
                            </div>
                            }
                            @if (
                            editDBMetersForm.controls["deviceId"].errors[
                            "pattern"
                            ]
                            ) {
                            <div>
                              {{ Umd_Validations.deviceId.pattern }}
                            </div>
                            }
                            @if (
                            editDBMetersForm.controls["deviceId"].errors[
                            "maxlength"
                            ]
                            ) {
                            <div>
                              {{ Umd_Validations.deviceId.maxlength }}
                            </div>
                            }

                          </div>
                          }
                        </div>
                      </div>
                    </div>
                  </form>
                  <!-- If approvalStatus is either AgentMapped or AgentUnmapped → ❌ Hide button.

                                                         If projectId is empty or null → ✅ Show button. -->
                  <ul class="list-inline wizard d-flex justify-content-end mb-0 mt-5" *ngIf="
                        metersDBData?.approvalStatus !== 'AgentMapped' &&
                        metersDBData?.approvalStatus !== 'AgentUnmapped' &&
                        !metersDBData?.projectId
                      ">
                    <li class="previous list-inline-item">
                      <button class="btn btn-primary" (click)="UpdateDBMeters()">
                        Update
                      </button>
                    </li>
                  </ul>
                </section>
                }
              </cdk-step>
              <cdk-step [optional]="true">
                <ng-template cdkStepLabel>
                  <span>Mapping </span>
                </ng-template>
                @if (cdkStepper.selectedIndex === 1) {
                <section class="">
                  <div class="row">
                    <div class="col-lg-12">
                      <div class="card">
                        <div class="card-body">
                          <form class="form-horizontal" [formGroup]="mappingDBMetersForm">
                            <div class="row">
                              <div class="col-lg-4">
                                <div class="mb-3">
                                  <label for="b">Project
                                    <span class="required">*</span></label>

                                  <ng-select [items]="configData?.projects" placeholder="Select projects"
                                    formControlName="projectIds" bindLabel="name" bindValue="id"
                                    (change)="onFilterProjectsChange($event)" [multiple]="false"
                                    [deselectOnClick]="true">
                                  </ng-select>
                                  @if (
                                  isSubmitted &&
                                  mapping["projectIds"].errors
                                  ) {
                                  <div class="invalid-feedback">
                                    @if (
                                    mapping["projectIds"].errors[
                                    "required"
                                    ]
                                    ) {
                                    <div>
                                      {{
                                      prifileValidations.project_required_validations
                                      }}
                                    </div>
                                    }
                                  </div>
                                  }
                                </div>
                              </div>

                              <div class="col-lg-4">
                                <div class="mb-3">
                                  <label>Residential Unit
                                    <span class="required">*</span></label>
                                  <ng-select [items]="
                                        conficdatabyProject?.residentialUnits
                                      " bindLabel="flatNo" id="residentialUnit" name="residentialUnit" bindValue="id"
                                    formControlName="residentialUnit" [multiple]="false" [placeholder]="'Select...'"
                                    (change)="changeResidentialUnit($event)"></ng-select>
                                  @if (
                                  isSubmitted &&
                                  mappingDBMetersForm.controls[
                                  "residentialUnit"
                                  ].errors
                                  ) {
                                  <div class="invalid-feedback">
                                    @if (
                                    mappingDBMetersForm.controls[
                                    "residentialUnit"
                                    ].errors["required"]
                                    ) {
                                    <div>
                                      {{
                                      Umd_Validations.utilityMasterId
                                      .residentialUnit
                                      }}
                                    </div>
                                    }
                                  </div>
                                  }
                                </div>
                              </div>

                              <div class="col-lg-4" *ngIf="
                                    metersDBData?.isWiredCommunicationDevice
                                  ">
                                <div class="mb-3">
                                  <label>Gateway Serial Number
                                    <span class="required">*</span></label>

                                  <ng-select [items]="conficdatabyProject.gateways" placeholder="Select"
                                    (change)="changeGateways($event)" formControlName="gatewayInformationId"
                                    bindLabel="serialNumber" bindValue="id" [multiple]="false" [deselectOnClick]="true">
                                  </ng-select>
                                  @if (
                                  isSubmitted &&
                                  mapping["gatewayInformationId"].errors
                                  ) {
                                  <div class="invalid-feedback">
                                    @if (
                                    mapping["gatewayInformationId"]
                                    .errors["required"]
                                    ) {
                                    <div>
                                      {{ prifileValidations.gatewaysID }}
                                    </div>
                                    }
                                  </div>
                                  }
                                </div>
                              </div>
                              <div class="col-lg-4">
                                <div class="mb-3">
                                  <label for="basicpill-lastname-input">Installed Location
                                    <span class="required">*</span></label>
                                  <input type="text" class="form-control" name="installed_Location"
                                    id="installed_Location" formControlName="installed_Location"
                                    placeholder="Enter Installed Location" />
                                  @if (
                                  isSubmitted &&
                                  mapping["installed_Location"].errors
                                  ) {
                                  <div class="invalid-feedback">
                                    @if (
                                    mapping["installed_Location"].errors[
                                    "required"
                                    ]
                                    ) {
                                    <div>
                                      {{
                                      prifileValidations.InstalledLocation
                                      }}
                                    </div>
                                    }
                                    @if (
                                    mapping["installed_Location"].errors[
                                    "pattern"
                                    ]
                                    ) {
                                    <div>
                                      {{
                                      prifileValidations.OnlyAlphanumeric_patten
                                      }}
                                    </div>
                                    }

                                    @if (
                                    mapping["installed_Location"].errors[
                                    "maxlength"
                                    ]
                                    ) {
                                    <div>
                                      {{ prifileValidations.maxlimit }}
                                    </div>
                                    }
                                  </div>
                                  }
                                </div>
                              </div>

                              <div class="col-lg-4">
                                <div class="mb-3">
                                  <label for="basicpill-lastname-input">Meter Installation Date
                                    <span class="required">*</span>
                                  </label>

                                  <input type="text" class="form-control date" placeholder="Select Date"
                                    name="singleDate" autocomplete="off" bsDatepicker #datepickergas1="bsDatepicker"
                                    [bsConfig]="metresdatePickerConfig" formControlName="meterInstallation_Date"
                                    (keydown)="preventManualInput($event)" />
                                  <span class="bx bx-calendar inputIcon-meter_gas" *ngIf="
                                        !mappingDBMetersForm.get(
                                          'meterInstallation_Date'
                                        )?.value
                                      " [class.disabled-icon]="
                                        mappingDBMetersForm.get(
                                          'meterInstallation_Date'
                                        )?.disabled
                                      " (click)="datepickergas1.show()"></span>
                                  <span class="bx bx-x inputIcon-meter_gas clear-icon" [class.disabled-icon]="
                                        mappingDBMetersForm.get(
                                          'meterInstallation_Date'
                                        )?.disabled
                                      " *ngIf="
                                        mappingDBMetersForm.get(
                                          'meterInstallation_Date'
                                        )?.value
                                      " (click)="clearDate_meter()"></span>

                                  @if (
                                  isSubmitted &&
                                  mapping["meterInstallation_Date"].errors
                                  ) {
                                  <div class="invalid-feedback">
                                    @if (
                                    mapping["meterInstallation_Date"]
                                    ?.errors?.["required"]
                                    ) {
                                    <div>
                                      {{
                                      prifileValidations.Meter_Installation_Date
                                      }}
                                    </div>
                                    }
                                  </div>
                                  }
                                </div>
                              </div>

                              <div class="col-lg-4" *ngIf="isGasUtility()">
                                <div class="mb-3">
                                  <label>Meter Reading Index<span class="required">*</span></label>
                                  <input type="text" class="form-control" name="meterReadingIndex"
                                    id="meterReadingIndex" maxlength="8" formControlName="meterReadingIndex"
                                    placeholder="Enter Meter Reading Index" />
                                  @if (
                                  isSubmitted &&
                                  mapping["meterReadingIndex"].errors
                                  ) {
                                  <div class="invalid-feedback">
                                    @if (
                                    mapping["meterReadingIndex"]?.errors?.[
                                    "required"
                                    ]
                                    ) {
                                    <div>
                                      {{
                                      prifileValidations.MeterReadingIndex
                                      }}
                                    </div>
                                    }
                                    @if (
                                    mapping["meterReadingIndex"]?.errors?.[
                                    "pattern"
                                    ]
                                    ) {
                                    <div>
                                      {{
                                      prifileValidations.minmaxPattern
                                      }}
                                    </div>
                                    }
                                    @if (
                                    mapping["meterReadingIndex"].errors[
                                    "maxlength"
                                    ]
                                    ) {
                                    <div>
                                      {{ prifileValidations.minmaxReadingIndex }}
                                    </div>
                                    }
                                    @if (
                                    mapping["meterReadingIndex"].errors[
                                    "minlength"
                                    ]
                                    ) {
                                    <div>
                                      {{ prifileValidations.minmaxReadingIndex }}
                                    </div>
                                    }
                                  </div>
                                  }
                                </div>
                              </div>

                              <div class="col-lg-4" *ngIf="isGasOrWaterUtility()">
                                <div class="mb-3">
                                  <label for="basicpill-lastname-input">Initial Reading<span class="required">*</span>
                                  </label>
                                  <input type="text" class="form-control" name="initialReading" id="initialReading"
                                    formControlName="initialReading" placeholder="Enter Initial Reading" />
                                  @if (
                                  isSubmitted &&
                                  mapping["initialReading"].errors
                                  ) {
                                  <div class="invalid-feedback">
                                    @if (
                                    mapping["initialReading"]?.errors?.[
                                    "required"
                                    ]
                                    ) {
                                    <div>
                                      {{
                                      prifileValidations.InitialReading
                                      }}
                                    </div>
                                    }
                                    @if (
                                    mapping["initialReading"]?.errors?.[
                                    "pattern"
                                    ]
                                    ) {
                                    <div>
                                      {{
                                      prifileValidations.OnlyNumberDecimal_patten
                                      }}
                                    </div>
                                    }

                                    @if (
                                    mapping["initialReading"]?.errors?.[
                                    "maxLimit"
                                    ]
                                    ) {
                                    <div>
                                      {{
                                      prifileValidations.Initialreading_water
                                      }}
                                    </div>
                                    }
                                  </div>
                                  }
                                </div>
                              </div>

                              <div class="col-lg-4" *ngIf="isElectricityOrTriSourceUtility()">
                                <div class="mb-3">
                                  <label for="basicpill-lastname-input">Meter Initial Reading EB (kWh)
                                    <span class="required">*</span></label>
                                  <input type="text" class="form-control" name="meter_Initial_Reading_EB_KWH"
                                    id="meter_Initial_Reading_EB_KWH" formControlName="meter_Initial_Reading_EB_KWH" />
                                  @if (
                                  isSubmitted &&
                                  mapping["meter_Initial_Reading_EB_KWH"]
                                  .errors
                                  ) {
                                  <div class="invalid-feedback d-block">
                                    @if (
                                    mapping[
                                    "meter_Initial_Reading_EB_KWH"
                                    ]?.errors?.["required"]
                                    ) {
                                    <div>
                                      {{
                                      prifileValidations.Meter_Initial_Reading_EB_KWH
                                      }}
                                    </div>
                                    }
                                    @if (
                                    mapping[
                                    "meter_Initial_Reading_EB_KWH"
                                    ]?.errors?.["pattern"]
                                    ) {
                                    <div>
                                      {{
                                      prifileValidations.OnlyNumberDecimal_patten
                                      }}
                                    </div>
                                    }

                                    @if (
                                    mapping[
                                    "meter_Initial_Reading_EB_KWH"
                                    ]?.errors?.["maxLimit"]
                                    ) {
                                    <div>
                                      {{
                                      prifileValidations.Initialreading
                                      }}
                                    </div>
                                    }
                                  </div>
                                  }
                                </div>
                              </div>
                              <div class="col-lg-4" *ngIf="isElectricityOrTriSourceUtility()">
                                <div class="mb-3">
                                  <label for="basicpill-lastname-input">Meter Initial Reading DG (kWh)
                                    <span class="required">*</span></label>
                                  <input type="text" class="form-control" name="meter_Initial_Reading_DG_KWH"
                                    id="meter_Initial_Reading_DG_KWH" formControlName="meter_Initial_Reading_DG_KWH" />
                                  @if (
                                  isSubmitted &&
                                  mapping["meter_Initial_Reading_DG_KWH"]
                                  .errors
                                  ) {
                                  <div class="invalid-feedback">
                                    @if (
                                    mapping[
                                    "meter_Initial_Reading_DG_KWH"
                                    ]?.errors?.["required"]
                                    ) {
                                    <div>
                                      {{
                                      prifileValidations.Meter_Initial_Reading_DG_KWH
                                      }}
                                    </div>
                                    }
                                    @if (
                                    mapping[
                                    "meter_Initial_Reading_DG_KWH"
                                    ]?.errors?.["pattern"]
                                    ) {
                                    <div>
                                      {{
                                      prifileValidations.OnlyNumberDecimal_patten
                                      }}
                                    </div>
                                    }

                                    @if (
                                    mapping[
                                    "meter_Initial_Reading_DG_KWH"
                                    ]?.errors?.["maxLimit"]
                                    ) {
                                    <div>
                                      {{
                                      prifileValidations.Initialreading
                                      }}
                                    </div>
                                    }
                                  </div>
                                  }
                                </div>
                              </div>
                              <div class="col-lg-4" *ngIf="isTriSourceUtility()">
                                <div class="mb-3">
                                  <label for="basicpill-lastname-input">Meter Initial Reading Solar (kWh)
                                    <span class="required">*</span></label>
                                  <input type="text" class="form-control" name="meter_Initial_Reading_Solar_KWH"
                                    id="meter_Initial_Reading_Solar_KWH"
                                    formControlName="meter_Initial_Reading_Solar_KWH" />
                                  @if (
                                  isSubmitted &&
                                  mapping["meter_Initial_Reading_Solar_KWH"]
                                  .errors
                                  ) {
                                  <div class="invalid-feedback">
                                    @if (
                                    mapping[
                                    "meter_Initial_Reading_Solar_KWH"
                                    ]?.errors?.["required"]
                                    ) {
                                    <div>
                                      {{
                                      prifileValidations.Meter_Initial_Reading_Solar_KWH
                                      }}
                                    </div>
                                    }
                                    @if (
                                    mapping[
                                    "meter_Initial_Reading_Solar_KWH"
                                    ]?.errors?.["pattern"]
                                    ) {
                                    <div>
                                      {{
                                      prifileValidations.OnlyNumberDecimal_patten
                                      }}
                                    </div>
                                    }

                                    @if (
                                    mapping[
                                    "meter_Initial_Reading_Solar_KWH"
                                    ]?.errors?.["maxLimit"]
                                    ) {
                                    <div>
                                      {{
                                      prifileValidations.Initialreading
                                      }}
                                    </div>
                                    }
                                  </div>
                                  }
                                </div>
                              </div>

                              <div class="col-lg-4">
                                <div class="mb-3">
                                  <label for="basicpill-lastname-input">Meter Initial Reading Date<span
                                      class="required">*</span>
                                  </label>
                                  <input type="text" class="form-control date" placeholder="Select Date"
                                    name="singleDate" autocomplete="off" bsDatepicker #datepickergas2="bsDatepicker"
                                    [bsConfig]="metresdatePickerConfig" formControlName="meter_InitialReadingDate"
                                    (keydown)="preventManualInput($event)" />
                                  <span class="bx bx-calendar inputIcon-meter_gas" *ngIf="
                                        !mappingDBMetersForm.get(
                                          'meter_InitialReadingDate'
                                        )?.value
                                      " [class.disabled-icon]="
                                        mappingDBMetersForm.get(
                                          'meter_InitialReadingDate'
                                        )?.disabled
                                      " (click)="datepickergas2.show()"></span>
                                  <span class="bx bx-x inputIcon-meter_gas clear-icon" [class.disabled-icon]="
                                        mappingDBMetersForm.get(
                                          'meter_InitialReadingDate'
                                        )?.disabled
                                      " *ngIf="
                                        mappingDBMetersForm.get(
                                          'meter_InitialReadingDate'
                                        )?.value
                                      " (click)="clearDategas_Initial_meter()"></span>
                                  @if (
                                  isSubmitted &&
                                  mapping["meter_InitialReadingDate"].errors
                                  ) {
                                  <div class="invalid-feedback">
                                    @if (
                                    mapping["meter_InitialReadingDate"]
                                    .errors["required"]
                                    ) {
                                    <div>
                                      {{
                                      prifileValidations.MeterinitialReadingDate
                                      }}
                                    </div>
                                    }
                                  </div>
                                  }
                                </div>
                              </div>

                              <div class="col-lg-4" *ngIf="!isAgentAdmin()">
                                <div class="mb-3">
                                  <label>Location Coordinates</label>
                                  <input type="text" formControlName="location" id="location" class="form-control"
                                    [placeholder]="mappingDBMetersForm.get('location')?.disabled && !mappingDBMetersForm.get('location')?.value ? '' : 'Enter location Number'" />
                                </div>
                              </div>
                              <div class="col-lg-4" *ngIf="isAgentAdmin()">
                                <div class="mb-3">
                                  <label>Location Coordinates</label>
                                  <input type="text" formControlName="location" id="agentAdminLocation"
                                    class="form-control" />
                                </div>
                              </div>
                              <div class="col-lg-4">
                                <div class="mb-3">
                                  <label>Photo </label>
                                  <kendo-upload *ngIf="!isAgentAdmin() && (metersDBData?.approvalStatus === 'Rejected' || !isMeterMapped())" [saveUrl]="uploadSaveUrl"
                                    class="meter-photo-upload" [class.upload-complete]="uploadLocked"
                                    [removeUrl]="uploadRemoveUrl" formControlName="files" [multiple]="true"
                                    (select)="handleFileSelected($event)" (upload)="onUpload($event)"
                                    (success)="onSuccess($event)" (error)="onUploadError($event)" [concurrent]="false"
                                    (remove)="onRemove($event)" (cancel)="onUploadCancel($event)"
                                    [restrictions]="myRestrictions"
                                    accept=".png,.jpg,.jpeg">
                                  </kendo-upload>
                                  <div *ngIf="!imagePreviews.length && (isAgentAdmin() || isMeterMapped() || mappingDBMetersForm.valid)" class="meter-no-photos">
                                    No Photos to display
                                  </div>
                                  <div *ngIf="imagePreviews.length" class="meter-image-carousel-container">
                                    <div class="meter-image-carousel">
                                      <button *ngIf="imagePreviews.length > 1" type="button"
                                        class="meter-carousel-nav meter-carousel-nav-prev" aria-label="Previous image"
                                        [disabled]="currentImageIndex === 0" (click)="previousImage()">
                                        &lt;
                                      </button>

                                      <button type="button" class="meter-image-display" (click)="
                                            openImagePreview(
                                              imagePreviewModal,
                                              imagePreviews[currentImageIndex]
                                            )
                                          " kendoTooltip title="View image">
                                        <img [src]="imageSrc || imagePreviews[currentImageIndex]"
                                          [alt]="'Meter photo ' + (currentImageIndex + 1)" />
                                      </button>

                                      <button *ngIf="imagePreviews.length > 1" type="button"
                                        class="meter-carousel-nav meter-carousel-nav-next" aria-label="Next image"
                                        [disabled]="currentImageIndex === imagePreviews.length - 1"
                                        (click)="nextImage()">
                                        &gt;
                                      </button>
                                    </div>

                                    <div class="meter-carousel-counter">
                                      {{ currentImageIndex + 1 }} / {{ imagePreviews.length }}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </form>
                          <ul class="list-inline wizard d-flex justify-content-end mb-0 mt-4">
                            <!-- Map Button -->
                            <li class="list-inline-item" *ngIf="canShowMapAction()">
                              <button class="btn btn-success" [disabled]="isMapActionDisabled()"
                                (click)="mapUmpConfirmation('map')">
                                Map
                              </button>
                            </li>

                            <!-- Unmap Button -->

                            <li class="list-inline-item" *ngIf="canShowUnmapAction()">
                              <button class="btn btn-danger" (click)="mapUmpConfirmation('unmap')">
                                Unmap
                              </button>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
                }
              </cdk-step>
              <cdk-step [optional]="true">
                <ng-template cdkStepLabel>
                  <span>Mapping history</span>
                </ng-template>
                @if (cdkStepper.selectedIndex === 2) {
                <section class="">
                  <div class="card-body">
                    <ng-template #template let-anchor>
                      <span>{{ anchor.nativeElement.innerText }}</span>
                    </ng-template>

                    <div kendoTooltip showOn="none" [tooltipTemplate]="template" filter=".k-grid td"
                      (mouseover)="showTooltip($event)">
                      <kendo-grid [data]="meterDBgridData" [pageSize]="pageSize" [skip]="skip" [sortable]="true"
                        [selectable]="selectableSettings" [pageable]="{
                            buttonCount: buttonCount,
                            info: info,
                            type: type,
                            pageSizes: pageSizes,
                            previousNext: previousNext,
                          }" [reorderable]="true" filterable="menu" [filter]="meterState.filter"
                        [sort]="meterState.sort" [columnMenu]="{ filter: true }"
                        (filterChange)="onMeterFilterChange($event)" (sortChange)="onSortChange($event)"
                        [resizable]="true" scrollable="scrollable" (pageChange)="meterConfigPageChange($event)"
                        (selectionChange)="selectionChanged($event)" (dataStateChange)="dataStateChange($event)">
                        <ng-template kendoGridToolbarTemplate>
                          <div class="search_icon">
                            <kendo-textbox [style.width.px]="250" [clearButton]="true"
                              (valueChange)="onValueChange($event)" (keyup.enter)="onSearchMeterAds()"
                              [style.height.px]="35" [(ngModel)]="searchedValue" placeholder="Search in all columns...">
                            </kendo-textbox>

                            <button class="btn btn-primary btn-md border-left-none"
                              (click)="onMeterConfigFilter($event)">
                              <i class="fa fa-search"></i>
                            </button>
                          </div>

                          <kendo-grid-spacer></kendo-grid-spacer>

                          <div class="sm-device d-flex justify-content-between">
                            <button class="btn btn-outline-primary btn-sm" (click)="onMeterExport()">
                              <span class="fas fa-file-excel"> </span> &nbsp;
                              Export to Excel
                            </button>
                          </div>
                        </ng-template>

                        <kendo-grid-checkbox-column [columnMenu]="false" [showSelectAll]="true" [width]="40"
                          class="no-tooltip"></kendo-grid-checkbox-column>
                        <kendo-grid-column field="macAddress" title="Mac Address" [width]="100"></kendo-grid-column>
                        <kendo-grid-column field="deviceSerialNumber" title="Device Sr No" [width]="100">
                          <ng-template kendoGridFilterMenuTemplate let-filter let-column="column">
                            <kendo-grid-string-filter-menu [column]="column" [filter]="filter">
                            </kendo-grid-string-filter-menu>
                            <small style="color: brown">Search is case-sensitive.</small>
                          </ng-template>
                        </kendo-grid-column>
                        <kendo-grid-column field="utility" title="Utility" [width]="100">
                          <ng-template kendoGridFilterMenuTemplate let-filter let-column="column">
                            <kendo-grid-string-filter-menu [column]="column" [filter]="filter">
                            </kendo-grid-string-filter-menu>
                            <small style="color: brown">Search is case-sensitive.</small>
                          </ng-template>
                        </kendo-grid-column>

                        <kendo-grid-column field="isWired" title="Is Wired" [width]="90" filter="boolean">
                          <ng-template kendoGridCellTemplate let-dataItem>
                            {{ dataItem.isWired ? 'Yes' : 'No' }}
                          </ng-template>
                        </kendo-grid-column>
                        <kendo-grid-column field="deviceId" title="Device Id " [width]="90">
                        </kendo-grid-column>
                        <kendo-grid-column field="flatNo" title="Residential Unit" [width]="90">
                        </kendo-grid-column>

                        <kendo-grid-column field="gatewaySerialNumber" title="Gateway Serial Number" [width]="90">
                        </kendo-grid-column>
                        <kendo-grid-column field="reason" title="Reason" [width]="90" [hidden]="true">
                        </kendo-grid-column>

                        <kendo-grid-column field="actionDate" title="Action Date" filter="date" [width]="90">
                          <ng-template kendoGridCellTemplate let-dataItem>
                            {{
                            dataItem.actionDate
                            | date: "dd MMM yyyy hh:mm a"

                            }}
                          </ng-template>
                        </kendo-grid-column>

                        <kendo-grid-column field="actionBy" title="Action By" [width]="90">
                        </kendo-grid-column>

                        <kendo-grid-column field="action" title="Action" [width]="100">
                        </kendo-grid-column>
                      </kendo-grid>
                    </div>

                    <div style="
                          position: absolute;
                          top: 0;
                          left: -10000px;
                          width: 500px;
                        ">
                      <kendo-grid [kendoGridBinding]="
                            mySelectionMeter.length > 0
                              ? mySelectionMeter
                              : meterDBgridData.data
                          " #pdfGrid>
                        <kendo-grid-column field="macAddress" title="Mac Address" [width]="100"></kendo-grid-column>
                        <kendo-grid-column field="deviceSerialNumber" title="Device Sr No" [width]="100">
                          <ng-template kendoGridFilterMenuTemplate let-filter let-column="column">
                            <kendo-grid-string-filter-menu [column]="column" [filter]="filter">
                            </kendo-grid-string-filter-menu>
                            <small style="color: brown">Search is case-sensitive.</small>
                          </ng-template>
                        </kendo-grid-column>
                        <kendo-grid-column field="utility" title="Utility" [width]="100">
                          <ng-template kendoGridFilterMenuTemplate let-filter let-column="column">
                            <kendo-grid-string-filter-menu [column]="column" [filter]="filter">
                            </kendo-grid-string-filter-menu>
                            <small style="color: brown">Search is case-sensitive.</small>
                          </ng-template>
                        </kendo-grid-column>

                        <kendo-grid-column field="is_wired" title="Is Wired" [width]="90" filter="boolean">
                        </kendo-grid-column>
                        <kendo-grid-column field="deviceId" title="Device Id " [width]="90">
                        </kendo-grid-column>
                        <kendo-grid-column field="flatNo" title="Residential Unit" [width]="90">
                        </kendo-grid-column>

                        <kendo-grid-column field="gatewaySerialNumber" title="Gateway Serial Number" [width]="90">
                        </kendo-grid-column>
                        <kendo-grid-column field="reason" title="Reason" [width]="90">
                        </kendo-grid-column>

                        <kendo-grid-column field="Action_date" title="Action Date" [width]="90">
                        </kendo-grid-column>

                        <kendo-grid-column field="actionBy" title="Action By" [width]="90">
                        </kendo-grid-column>

                        <kendo-grid-column field="action" title="Action" [width]="90">
                        </kendo-grid-column>
                        <kendo-grid-excel fileName="Mapping History.xlsx"></kendo-grid-excel>
                      </kendo-grid>
                    </div>
                  </div>
                </section>
                }
              </cdk-step>
            </ng-stepper>
          </div>
        </div>
      </div>
    </div>
  </div>

  <ng-template #imagePreviewModal>
    <div class="meter-photo-modal">
      <div class="modal-header">
        <h5 class="modal-title">Meter Photos</h5>
        <button type="button" class="btn-close" aria-label="Close" (click)="imagePreviewModalRef?.hide()"></button>
      </div>

      <div *ngIf="imagePreviews?.length" class="meter-photo-carousel p-2">
        <div class="meter-photo-carousel-stage">
          <button *ngIf="imagePreviews.length > 1" type="button" class="meter-carousel-nav meter-carousel-nav-prev"
            aria-label="Previous image" [disabled]="currentImageIndex === 0" (click)="previousImage()">
            &lt;
          </button>

          <img [src]="imagePreviews[currentImageIndex]" [alt]="'Meter photo ' + (currentImageIndex + 1)"
            class="meter-carousel-image" />

          <button *ngIf="imagePreviews.length > 1" type="button" class="meter-carousel-nav meter-carousel-nav-next"
            aria-label="Next image" [disabled]="currentImageIndex === imagePreviews.length - 1" (click)="nextImage()">
            &gt;
          </button>
        </div>

        <div class="meter-carousel-counter">
          {{ currentImageIndex + 1 }} / {{ imagePreviews.length }}
        </div>
      </div>
    </div>
  </ng-template>

  <!-- Invalid Bill modal -->
  <ng-template #invalidBillModal>
    <div class="">
      <div class="">
        <div class="modal-header">
          <h5 class="modal-title">Rejected Reason</h5>
          <button type="button" class="btn-close text-white" data-bs-dismiss="modal" aria-label="Close"
            (click)="modalRefReasons?.hide()"></button>
        </div>
        <div class="modal-body">
          <div class="mb-3">
            <label> Reason for Reject<span class="required">*</span></label>
            <textarea [placeholder]="'Enter your reason here'" [(ngModel)]="reason" (ngModelChange)="validateReason()"
              class="form-control" rows="5"></textarea>
            <!--  <span *ngIf="!reason"></span> -->
            <div class="text-danger" *ngIf="reasonError">
              Reason cannot be empty or just spaces.
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <!-- <button type="button" class="btn btn-secondary waves-effect" data-bs-dismiss="modal" >Close</button> -->
          <button type="button" class="btn btn-primary waves-effect waves-light" (click)="saveReject()"
            [disabled]="!reason">
            Submit
          </button>
        </div>
      </div>
      <!-- /.modal -->
    </div>
  </ng-template>
  <!-- Invalid Bill modal End  -->
</div>
